import { render, staticRenderFns } from "./SocialBookingSlotsCalendar.vue?vue&type=template&id=28b3c076&"
import script from "./SocialBookingSlotsCalendar.vue?vue&type=script&lang=js&"
export * from "./SocialBookingSlotsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SocialBookingSlotsCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports